export const ID_FILTER_APPLIEDON = "applied-on";
export const ID_FILTER_PRINTOUTTYPE = "printout-type";
export const ID_FILTER_SPECIAL = "special";
export const ID_FILTER_ORDER = "order";
export const ID_FILTER_VOICE = "voice";
export const ID_FILTER_SEARCH = 'search';
export const ID_FILTER_SEGMENT = 'segment';